const HEADER_HEIGHT = 58;
const DEFAULT_ROW_HEIGHT = 56;
const MAX_MIN_ROWS = 5;

export function getTableMinHeight(recordsPerPage: number, rowHeight: number = DEFAULT_ROW_HEIGHT) {
  return HEADER_HEIGHT + rowHeight * Math.min(recordsPerPage, MAX_MIN_ROWS);
}

export function getTableMinWidth(columns: readonly { size?: number }[]) {
  return columns.reduce((total, column) => total + (column.size ?? 150), 0);
}
